import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IIcon } from '../../icon/icon.component';
import { ButtonStyle } from '../../../directives/button/button.directive';

@Component({
  selector: 'i2g-dialog-base',
  templateUrl: './dialog-base.component.html',
  styleUrls: ['./dialog-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogBaseComponent implements OnInit {
  @Input() icon: IIcon;
  @Input() title: string;
  @Input() body: string;
  @Input() primaryButtonText: string;
  @Input() primaryButtonStyle: ButtonStyle = 'emphasis';
  @Input() secondaryButtonText: string;
  @Input() disablePrimaryButton = false;
  @Input() disableSecondaryButton = false;

  @Output() primaryButtonClicked = new EventEmitter<void>();
  @Output() secondaryButtonClicked = new EventEmitter<void>();

  @HostBinding('class') hostClass;

  constructor() {}

  ngOnInit() {
    this.hostClass = this.icon ? 'larger-version' : '';
  }
}
